import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import React, { ChangeEvent, useRef, useState } from "react";
import { editSummon } from "services/advocateComplaintService";
import { AdvocateComplaints, Prosecutor, Summon } from "types";
import { LoadingIcon } from "utils/constant";
import { useTranslation } from "contexts/i18nContext";

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  summonData: Summon;
  complaintData: AdvocateComplaints;
  onRefresh: any;
}

export default function AddSummonResponse({
  isOpen,
  setIsOpen,
  summonData,
  complaintData,
  onRefresh,
}: ModalProps) {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({
    accused_prosecutor: null as Prosecutor | null,
    files: [] as File[],
  });

  // const handleChange = (
  //   e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  // ) => {
  //   const { name, value } = e.target;
  //   setFormState((prev) => ({ ...prev, [name]: value }));
  // };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormState((prev) => ({
        ...prev,
        files: [...Array.from(e.target.files as FileList)],
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!summonData) {
      showToast(t("summonLetterNotFound"), "error");
      return;
    }

    if (!formState.files || formState.files.length === 0) {
      showToast(t("uploadResponseFile"), "error");
      return;
    }

    setLoading(true);
    const data = new FormData();
    data.append("accused_response_files", (formState?.files ?? [])[0] || "");
    // data.append("response_summary", formState?.response_summary ?? "");
    data.append("admin_unit_id", complaintData?.admin_unit_id || "");
    data.append("org_id", complaintData?.org_id || "");
    data.append("accused_advocate_name", complaintData?.accused_name || "");
    data.append(
      "user_id_accused_advocate",
      complaintData?.userid_accused_name || "",
    );
    data.append(
      "accused_license_number",
      complaintData?.accused_license_number || "",
    );
    data.append("accused_advocate_confirmed", true.toString());

    const summon_id = summonData?.id || "";
    const isFormData = true;

    try {
      await editSummon(data, summon_id, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast(t("successfullyCreated"), "success");
      setFormState({
        accused_prosecutor: null,
        files: [] as File[],
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("submissionError"), "error");
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <SideModal isOpen={isOpen} setIsOpen={setIsOpen} title={t("addResponse")}>
      <form onSubmit={handleSubmit} className="victim-form">
        <section className="evidence-section">
          {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("responseSummary")}
            </label>
            <textarea
              required
              rows={3}
              name="response_summary"
              value={formState.response_summary ?? ""}
              onChange={handleChange}
              placeholder={t("detailsHere")}
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div> */}

          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("responseFile")}
          </label>
          <div className="file-upload-area" onClick={triggerFileInput}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              // multiple
              style={{ display: "none" }}
            />
            <p className="upload-text">{t("uploadFiles")}</p>
            {formState?.files && formState?.files?.length > 0 && (
              <div className="file-list">
                {formState?.files?.map((file, index) => (
                  <div key={index} className="file-item">
                    {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              {t("submitting")}
            </div>
          ) : (
            t("submit")
          )}
        </button>
      </form>
    </SideModal>
  );
}
